import React from "react";
import IdInput from "../common/IdInput/IdInput";
import ReactTooltip from "react-tooltip";

const SiteFormComponent = ({
  title,
  siteName,
  siteCode,
  errorState,
  updateInputChange,
}) => {
  return (
    <>
      <p>{title}</p>
      <div
        className={`form-group position-relative error-l-75 mb-5 ${
          errorState.name ? "hasValidationError" : ""
        }`}
      >
        <label>
          <b>Site Name *</b>
        </label>
        <input
          type="text"
          required
          value={siteName}
          name="name"
          className="form-control"
          placeholder="Site Name"
          onChange={(e) => updateInputChange(e)}
        />
        <span className="validation-error-message">
          {errorState && errorState.name ? errorState.name : ""}
        </span>
      </div>

      <div
        className={`form-group position-relative error-l-75 mb-5 ${
          errorState.siteCode ? "hasValidationError" : ""
        }`}
      >
        <label>
          <b>Site Code *</b>
          <i
            className="iconsminds-information info-icon-small ml-1"
            data-tip="Maximum 20 characters allowed"
          />
        </label>

        <IdInput
          value={siteCode}
          onInput={(value) =>
            updateInputChange({ target: { name: "siteCode", value } })
          }
          isSite={true}
          className="form-control pr-5"
        />
        <span className="validation-error-message">
          {errorState && errorState.siteCode ? errorState.siteCode : ""}
        </span>
      </div>
      <ReactTooltip />
    </>
  );
};

export default SiteFormComponent;
